<template>
    <v-form v-model="isValid" @submit.prevent>
        <v-layout>
            <v-flex class="group-search-field mr-3">
                <v-text-field
                    v-model="keywords[0]"
                    :placeholder="placeholderName1"
                    :rules="[rules.maxChars(keywords[0], 256)]"
                    :disabled="isDisabled || isLoading"
                    class="text-body-2"
                    clearable
                    @keydown.13="searchIfCanPress"
                />
            </v-flex>
            <v-flex class="account-search-field">
                <v-text-field
                    v-model="keywords[1]"
                    :placeholder="placeholderName2"
                    :rules="[rules.maxChars(keywords[1], 256)]"
                    :disabled="isDisabled || isLoading"
                    class="text-body-2"
                    clearable
                    @keydown.13="searchIfCanPress"
                />
            </v-flex>
            <v-flex>
                <v-btn
                    :loading="isLoading"
                    :disabled="!isValid || isDisabled || isLoading"
                    fab
                    small
                    color="accent"
                    @click="$emit('click', keywords)"
                >
                    <v-icon dark> search </v-icon>
                </v-btn>
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script lang="ts">
import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import InputValidation from '../../../mixins/InputValidation';

@Component({
    name: 'ListSearchInputterDouble',
})
export default class ListSearchInputterDouble extends mixins(InputValidation) {
    @Prop({ default: ['', ''] }) value: Array<string>;
    @Prop({ default: undefined }) placeholder1: string;
    @Prop({ default: undefined }) placeholder2: string;
    @Prop({ default: false }) loading: boolean;
    @Prop({ default: false }) disabled: boolean;
    @Watch('value', { deep: true })
    onValueChanged(val: Array<string>): void {
        this.keywords = val;
    }
    @Watch('keywords', { deep: true })
    onKeywordChanged(val: string): void {
        this.$emit('input', val);
    }

    keywords = ['', ''];

    get isLoading(): boolean {
        return this.loading;
    }
    get isDisabled(): boolean {
        return this.disabled;
    }
    get placeholderName1(): string {
        return this.placeholder1;
    }
    get placeholderName2(): string {
        return this.placeholder2;
    }

    searchIfCanPress() {
        if (this.isDisabled || !this.isValid || this.isLoading) {
            return;
        }
        this.$emit('click', this.keywords);
    }
}
</script>

<style lang="scss" scoped>
.group-search-field {
    max-width: 25rem;
}
.account-search-field {
    max-width: 25rem;
}
</style>
